export const GOLFERS = [
    {
        name: "Adam Scott",
        position: 48,
        posQualifier: "T",
        curScore: "+14",
        rounds: [ 74,74,80,74 ],
        winnings: 40050,
    },
    {
        name: "Brian Harman",
        position: 53,
        posQualifier: "MC",
        curScore: "+5",
        rounds: [ 74,75,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Brooks Koepka",
        position: 53,
        posQualifier: "MC",
        curScore: "+6",
        rounds: [ 75,75,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Cameron Smith",
        position: 3,
        posQualifier: "T",
        curScore: "-5",
        rounds: [ 68,74,68,73 ],
        winnings: 870000,
    },
    {
        name: "Collin Morikawa",
        position: 5,
        posQualifier: "",
        curScore: "-4",
        rounds: [ 73,70,74,67 ],
        winnings: 600000,
    },
    {
        name: "Corey Conners",
        position: 6,
        posQualifier: "T",
        curScore: "-3",
        rounds: [ 70,73,72,70 ],
        winnings: 521500,
    },
    {
        name: "Dustin Johnson",
        position: 12,
        posQualifier: "T",
        curScore: "+1",
        rounds: [ 69,73,75,72 ],
        winnings: 330000,
    },
    {
        name: "Jon Rahm",
        position: 27,
        posQualifier: "T",
        curScore: "+4",
        rounds: [ 74,72,77,69 ],
        winnings: 111000,
    },
    {
        name: "Jordan Spieth",
        position: 53,
        posQualifier: "MC",
        curScore: "+6",
        rounds: [ 74,76,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Justin Thomas",
        position: 8,
        posQualifier: "T",
        curScore: "-1",
        rounds: [ 76,67,72,72 ],
        winnings: 450000,
    },
    {
        name: "Kevin Kisner",
        position: 44,
        posQualifier: "T",
        curScore: "+9",
        rounds: [ 75,70,75,77 ],
        winnings: 51000,
    },
    {
        name: "Matthew Fitzpatrick",
        position: 14,
        posQualifier: "T",
        curScore: "+2",
        rounds: [ 71,73,76,70 ],
        winnings: 225333,
    },
    {
        name: "Max Homa",
        position: 48,
        posQualifier: "T",
        curScore: "+14",
        rounds: [ 74,73,77,78 ],
        winnings: 40050,
    },
    {
        name: "Patrick Cantlay",
        position: 39,
        posQualifier: "T",
        curScore: "+7",
        rounds: [ 70,75,79,71 ],
        winnings: 63000,
    },
    {
        name: "Rory McIlroy",
        position: 2,
        posQualifier: "",
        curScore: "-7",
        rounds: [ 73,73,71,64 ],
        winnings: 1620000,
    },
    {
        name: "Sam Burns",
        position: 53,
        posQualifier: "MC",
        curScore: "+5",
        rounds: [ 75,74,'--','--' ],
        winnings: 10000,
    },
    {
        name: "Scottie Scheffler",
        position: 1,
        posQualifier: "",
        curScore: "-10",
        rounds: [ 69,67,71,71 ],
        winnings: 2700000,
    },
    {
        name: "Shane Lowry",
        position: 3,
        posQualifier: "T",
        curScore: "-5",
        rounds: [ 73,68,73,69 ],
        winnings: 870000,
    },
    {
        name: "Tiger Woods",
        position: 47,
        posQualifier: "",
        curScore: "+13",
        rounds: [ 71,74,78,78 ],
        winnings: 43500,
    },
    {
        name: "Tommy Fleetwood",
        position: 14,
        posQualifier: "T",
        curScore: "+2",
        rounds: [ 75,72,70,73 ],
        winnings: 225333,
    },
    {
        name: "Tony Finau",
        position: 35,
        posQualifier: "T",
        curScore: "+6",
        rounds: [ 71,75,74,74 ],
        winnings: 75562,
    },
    {
        name: "Tyrrell Hatton",
        position: 52,
        posQualifier: "",
        curScore: "+17",
        rounds: [ 72,74,79,80 ],
        winnings: 36000,
    },
    {
        name: "Viktor Hovland",
        position: 27,
        posQualifier: "T",
        curScore: "+4",
        rounds: [ 72,76,71,73 ],
        winnings: 111000,
    },
    {
        name: "Will Zalatoris",
        position: 6,
        posQualifier: "T",
        curScore: "-3",
        rounds: [ 71,72,75,67 ],
        winnings: 521250,
    },
    {
        name: "Xander Schauffele",
        position: 53,
        posQualifier: "MC",
        curScore: "+7",
        rounds: [ 74,77,'--','--' ],
        winnings: 10000,
    },
]
